export default class PicklistWithSameNameExistsError extends Error {
}
